module.exports = __webpack_public_path__ + "7a8ad8b4338efb3313d9d46a7c24f7a6.MP3";